<template>
  <div class="sectionBox3">
    <div class="topBox">
      <van-nav-bar
        title="确认订单信息"
        style="background: linear-gradient(to right, #75b9ff, #1b8bff)"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>
    <div class="cardBox">
      <div class="cardItem">
        <div class="left">
          <el-image class="images" :src="detailInfo.shopUrl"></el-image>
        </div>
        <div class="right">
          <div class="titles1">
            {{ detailInfo.shopName ? detailInfo.shopName : "---" }}
          </div>
          <div class="outBox">
            <div class="titles2">
              ￥
              <span v-if="detailInfo.shopDivideModel" style="font-size: 20px">
                {{ detailInfo.shopDivideModel.shopPrice }}
              </span>
              <span v-else style="font-size: 20px">
                {{ detailInfo.shopPrice ? detailInfo.shopPrice : 0 }}
              </span>
            </div>
            <div class="titles3">
              快递费:
              <span v-if="detailInfo.shopDivideModel" style="font-size: 20px">
                {{ detailInfo.shopDivideModel.shopPostAge }}元
              </span>
              <span v-else>
                {{ detailInfo.shopPostAge ? detailInfo.shopPostAge : 0 }}元
              </span>
            </div>
          </div>
          <div class="titles4">
            <van-stepper
              v-model="formData.buyNumber"
              min="1"
              step="1"
              integer
              input-width="34px"
              button-size="22px"
              @change="changeNumber"
            />
          </div>
        </div>
      </div>
      <div class="buyInfobox">
        <div style="text-align: left">
          <van-form @submit="onSubmit">
            <div
              style="
                border-radius: 10px;
                background-color: #fff;
                padding: 10px 15px;
              "
            >
              <div class="title" style="text-align: center">充值信息</div>
              <van-cell-group inset>
                <div class="formTitle">姓名</div>
                <van-field
                  v-model="formData.username"
                  name="username"
                  placeholder="请输入姓名"
                  class="inputBox"
                  :rules="[{ required: true, message: '请输入姓名' }]"
                />
                <div class="formTitle">手机号</div>
                <van-field
                  v-model="formData.userPhone"
                  name="userPhone"
                  placeholder="请输入手机号"
                  maxlength="11"
                  class="inputBox"
                  :rules="[{ required: true, message: '请输入手机号' }]"
                />
                <div class="formTitle" v-if="detailInfo.collectID == 1">
                  身份证号
                </div>
                <van-field
                  v-if="detailInfo.collectID == 1"
                  v-model="formData.collectID"
                  name="collectID"
                  minlength="18"
                  placeholder="请输入身份证号"
                  class="inputBox"
                  :rules="[{ required: true, message: '请输入身份证号' }]"
                />
                <div class="formTitle">收货地区</div>
                <van-field
                  class="inputBox"
                  v-model="formData.area"
                  is-link
                  readonly
                  name="area"
                  placeholder="请选择收货地区"
                  @click="showArea = true"
                  :rules="[{ required: true, message: '请选择收货地区' }]"
                />
                <van-popup v-model="showArea" position="bottom">
                  <van-area
                    :area-list="areaList"
                    @confirm="onConfirm"
                    @cancel="showArea = false"
                  />
                </van-popup>
                <div class="formTitle">详细地址</div>
                <van-field
                  v-model="formData.addressDetail"
                  name="addressDetail"
                  placeholder="请输入详细地址"
                  class="inputBox"
                  :rules="[{ required: true, message: '请输入详细地址' }]"
                />
                <div class="formTitle">备注信息</div>
                <van-field
                  v-model="formData.orderRemark"
                  name="orderRemark"
                  placeholder="请输入下单备注信息(非必填)"
                  class="inputBox_diff"
                  type="textarea"
                  rows="3"
                  autosize
                  :rules="[{ required: false, message: '请输入下单备注信息' }]"
                />
              </van-cell-group>
            </div>
            <div
              class="radioBox"
              style="
                border-radius: 10px;
                background-color: #fff;
                padding: 10px 0px;
                margin-top: 10px;
              "
            >
              <div
                style="
                  text-align: center;
                  color: #0096ff;
                  font-size: 14px;
                  font-weight: 500;
                  height: 38px;
                  line-height: 38px;
                  border-bottom: 1px solid #c5e1ff;
                  margin: 0px 15px;
                "
              >
                订单金额：{{
                  orderMoney ? Math.floor(orderMoney * 100) / 100 : 0
                }}元
              </div>
              <van-radio-group v-model="formData.payType">
                <van-cell-group inset>
                  <div v-for="(item, index) in payList" :key="index">
                    <van-cell clickable @click="formData.payType = item.id">
                      <template #title>
                        <el-image
                          style="
                            width: 18px;
                            height: 18px;
                            float: left;
                            margin-top: 2px;
                          "
                          :src="
                            item.imageUrl
                              ? item.imageUrl
                              : item.id == 1
                              ? require('../../assets/shopping/wechat.png')
                              : require('../../assets/shopping/alipay.png')
                          "
                          fit="fill"
                        ></el-image>
                        <span style="float: left; margin-left: 6px">
                          {{ item.name }}
                        </span>
                        <div v-if="isWeiXin() == true" class="recommend">
                          <div
                            v-if="item.systemRecommend == 1"
                            class="recommends"
                          >
                            推荐
                          </div>
                        </div>
                        <div v-else class="recommend">
                          <div v-if="item.appRecommend == 1" class="recommends">
                            推荐
                          </div>
                        </div>
                      </template>
                      <template #right-icon>
                        <van-radio :name="item.id" />
                      </template>
                    </van-cell>
                  </div>
                  <!-- <div v-if="payList[0].id">
                    <van-cell clickable @click="formData.payType = payList[0].id">
                      <template #title>
                        <el-image
                          style="
                          width: 18px;
                          height: 18px;
                          float: left;
                          margin-top: 2px;
                        "
                          :src="require('../../assets/shopping/wechat.png')"
                          fit="fill"
                        ></el-image>
                        <span style="float: left; margin-left: 6px">
                          {{
                          payList[0].name
                          }}
                        </span>
                      </template>
                      <template #right-icon>
                        <van-radio :name="payList[0].id" />
                      </template>
                    </van-cell>
                  </div>
                  <div v-if="payList[1].id">
                    <van-cell clickable @click="formData.payType = payList[1].id">
                      <template #title>
                        <el-image
                          style="
                          width: 18px;
                          height: 18px;
                          float: left;
                          margin-top: 2px;
                        "
                          :src="require('../../assets/shopping/alipay.png')"
                          fit="fill"
                        ></el-image>
                        <span style="float: left; margin-left: 6px">
                          {{
                          payList[1].name
                          }}
                        </span>
                      </template>
                      <template #right-icon>
                        <van-radio :name="payList[1].id" />
                      </template>
                    </van-cell>
                  </div>-->
                </van-cell-group>
              </van-radio-group>
            </div>
            <div class="buyBox" style="margin-top: 20px">
              <el-button class="btns" round block native-type="submit">
                确认支付
              </el-button>
            </div>
          </van-form>
        </div>
      </div>
    </div>
    <!-- 支付 -->
    <van-overlay :show="showBuy" @click="showBuy = false" z-index="2">
      <div class="wrapper2">
        <div class="block2" @click.stop>
          <div class="tit1">支付金额</div>
          <div class="tit2">￥ {{ orderMoney }}</div>
          <div>
            <van-radio-group v-model="payId">
              <van-cell-group inset>
                <div>
                  <van-cell
                    v-for="(item2, index2) in payListIn"
                    :key="index2"
                    clickable
                    @click="payId = item2.id"
                  >
                    <template #title>
                      <el-image
                        style="
                          width: 18px;
                          height: 18px;
                          float: left;
                          margin-top: 2px;
                        "
                        :src="
                          item2.imgUrl
                            ? item2.imgUrl
                            : formData.payType == 1
                            ? require('../../assets/shopping/wechat.png')
                            : require('../../assets/shopping/alipay.png')
                        "
                        fit="fill"
                      ></el-image>
                      <span style="float: left; margin-left: 6px">
                        {{ item2.showName }}
                      </span>

                      <div class="recommend">
                        <div v-if="item2.recommend == 1" class="recommends">
                          推荐
                        </div>
                      </div>
                    </template>
                    <template #right-icon>
                      <van-radio :name="item2.id" />
                    </template>
                  </van-cell>
                </div>
                <!-- <div v-if="payList[0].id">
                  <div v-if="formData.payType == payList[0].id">
                    <van-cell
                      v-for="(item, index) in payList[0].list"
                      :key="index"
                      clickable
                      @click="payId = item.id"
                    >
                      <template #title>
                        <el-image
                          style="
                          width: 18px;
                          height: 18px;
                          float: left;
                          margin-top: 2px;
                        "
                          :src="require('../../assets/shopping/wechat.png')"
                          fit="fill"
                        ></el-image>
                        <span style="float: left; margin-left: 6px">
                          {{
                          item.showName
                          }}
                        </span>
                      </template>
                      <template #right-icon>
                        <van-radio :name="item.id" />
                      </template>
                    </van-cell>
                  </div>
                </div>
                <div v-if="payList[1].id">
                  <div v-if="formData.payType == payList[1].id">
                    <van-cell
                      v-for="(item, index) in payList[1].list"
                      :key="index"
                      clickable
                      @click="payId = item.id"
                    >
                      <template #title>
                        <el-image
                          style="
                          width: 18px;
                          height: 18px;
                          float: left;
                          margin-top: 2px;
                        "
                          :src="require('../../assets/shopping/alipay.png')"
                          fit="fill"
                        ></el-image>
                        <span style="float: left; margin-left: 6px">
                          {{
                          item.showName
                          }}
                        </span>
                      </template>
                      <template #right-icon>
                        <van-radio :name="item.id" />
                      </template>
                    </van-cell>
                  </div>
                </div>-->
              </van-cell-group>
            </van-radio-group>
          </div>
          <el-button class="confirmBuyBtn" @click="confirmBuyBtn">
            确认支付
          </el-button>
        </div>
      </div>
    </van-overlay>
    <!-- 支付码 -->
    <van-overlay :show="showss" @click="showss = false" z-index="2">
      <div class="wrapper3">
        <div class="block3" @click.stop>
          <div class="titles">支付金额：{{ orderMoney }}元</div>
          <img
            style="width: 200px; height: 200px"
            :src="imagerurl"
            @touchend="downs"
          />
          <div class="tips">
            <div>长按二维码保存图片，或截图本页面</div>
            <div>
              打开{{ formData.payType == 1 ? "微信" : "支付宝" }}扫一扫进行支付
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import { areaList } from "@vant/area-data";
  import baseURL from "../../api/baseUrl";
  import {
    getShopAdminModel,
    getUserPayList,
    addShopOrder,
  } from "@/api/shopping";
  export default {
    data() {
      return {
        baseURL: baseURL,
        areaList: areaList,
        showArea: false,
        detailInfo: {},
        shopPricenew: "",
        orderMoney: "",
        formData: {
          buyNumber: 1,
          userName: "",
          userPhone: "",
          area: "",
          addressDetail: "",
          orderRemark: "",
          payType: "",
          collectID: "",
        },
        showBuy: false,
        payList: [],
        payListIn: [],
        payId: 1,
        buyNumber: 1,
        imagerurl: "",
        showss: false,
        appId: "",
      };
    },
    mounted() {
      if (this.$route.query.code) {
        this.wx(this.$route.query.code, 0, this);
      }

      this.getUserPayList();
      this.getShopAdminModel();
    },
    created() {},
    methods: {
      // 返回
      onClickLeft() {
        history.back();
      },
      // 数量更改
      changeNumber(value) {
        // console.log(value);
        // this.detailInfo.shopPrice = this.changeNumber * value;
        if (this.detailInfo.shopDivideModel) {
          this.orderMoney =
            this.detailInfo.shopDivideModel.shopPrice * value +
            this.detailInfo.shopDivideModel.shopPostAge;
        } else {
          this.orderMoney =
            this.detailInfo.shopPrice * value + this.detailInfo.shopPostAge;
        }

        this.buyNumber = value;
      },
      //下载图片
      downloadIamge(imgsrc, name) {
        //下载图片地址和图片名
        var image = new Image(); // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function () {
          var canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          var context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

          var a = document.createElement("a"); // 生成一个a元素
          var event = new MouseEvent("click"); // 创建一个单击事件
          a.download = name || "photo"; // 设置图片名称
          a.href = url; // 将生成的URL设置为a.href属性
          a.dispatchEvent(event); // 触发a的单击事件
        };
        image.src = imgsrc;
      }, // 改downs这个函数就行，downloadIamge（‘图片下载地址’，图片名字）
      downs() {
        // 主要是为了名字不重复
        var name = new Date().getTime();
        this.downloadIamge(this.imagerurl, `${name}`);
      },
      confirmBuyBtn1() {
        window.open("weixin://");
      },
      confirmBuyBtn2() {
        this.$router.push(`/course`);
      },
      onConfirm(areaValues) {
        this.showArea = false;
        this.formData.area = areaValues
          .filter((item) => !!item)
          .map((item) => item.name)
          .join("");
      },
      // 查询订单详情
      getShopAdminModel() {
        var cards = "";
        var userId = "";

        if (localStorage.getItem("userIds") != undefined) {
          cards = "";
          userId = localStorage.getItem("userIds");
        } else {
          cards = localStorage.getItem("meCardNum");
          userId = "";
        }
        let params = {
          id: Number(localStorage.getItem("shopDetailId")),
          meCardNum: cards,
          userId: userId,
        };
        getShopAdminModel(params).then((res) => {
          if (res.status) {
            if (res.data) {
              this.detailInfo = res.data;
              this.shopPricenew = this.detailInfo.shopPrice;
              if (this.detailInfo.shopDivideModel) {
                this.orderMoney =
                  this.detailInfo.shopDivideModel.shopPrice +
                  this.detailInfo.shopDivideModel.shopPostAge;
              } else {
                this.orderMoney =
                  this.detailInfo.shopPrice + this.detailInfo.shopPostAge;
              }
            }
          }
        });
      },
      //根据id值 从小到大排序
      // sortId(a, b) {
      //   return a.id - b.id;
      // },
      getUserPayList() {
        let isWechat = "";
        if (this.isWeiXin() == true) {
          isWechat = 3;
        } else {
          isWechat = 2;
        }
        getUserPayList(isWechat).then((res) => {
          if (res.status) {
            if (res.data) {
              res.data.forEach((item) => {
                item.list.forEach((items) => {
                  items.imgUrl = item.imageUrl;
                });
              });
              this.payList = res.data;
              this.formData.payType = res.data[0].id;
            }
          }
        });
      },
      // 立即购买
      onSubmit() {
        let params = {};
        // console.log(this.formData.payType);
        if (
          localStorage.getItem("userIds") ||
          localStorage.getItem("userIds") == ""
        ) {
          params = {
            shopId: this.detailInfo.id, //商品id、
            classId: this.detailInfo.shopClassId, //分类id
            userName: this.formData.username, //用户名
            userPhone: this.formData.userPhone, //手机号
            buyAddress: this.formData.area + this.formData.addressDetail, //用户地址
            orderRemark: this.formData.orderRemark, //备注
            // payType: this.formData.payType, //支付类型
            // card: localStorage.getItem("meCardNum"), //卡号
            buyNumber: this.buyNumber,
            userId: localStorage.getItem("userIds"),
            collectID: this.formData.collectID,
          };
        } else {
          params = {
            shopId: this.detailInfo.id, //商品id、
            classId: this.detailInfo.shopClassId, //分类id
            userName: this.formData.username, //用户名
            userPhone: this.formData.userPhone, //手机号
            buyAddress: this.formData.area + this.formData.addressDetail, //用户地址
            orderRemark: this.formData.orderRemark, //备注
            // payType: this.formData.payType, //支付类型
            card: localStorage.getItem("meCardNum"), //卡号
            buyNumber: this.buyNumber,
            collectID: this.formData.collectID,
          };
        }

        localStorage.setItem("buyJson", JSON.stringify(params));
        if (this.formData.userPhone.length != 11) {
          this.$toast.fail("请输入正确的手机号");
        } else if (
          this.detailInfo.collectID == 1 &&
          this.formData.collectID.length != 18
        ) {
          this.$toast.fail("请输入正确的身份证号");
        } else {
          let listnm = [];
          this.payList.forEach((item) => {
            if (item.id == this.formData.payType) {
              this.payListIn = item.list;
              listnm = item;
              if (item.list.length > 1) {
                this.showBuy = true;
              } else {
                this.showBuy = false;
                this.payId = this.payListIn[0].id;
                this.appId = this.payListIn[0].appId;
                if (item.id == 1) {
                  this.paylistFun(listnm);
                } else {
                  this.addShopOrderNew();
                }
              }
            }
          });
        }
      },
      paylistFun(list) {
        let codes = "";
        list.list.forEach((item) => {
          if (this.payId == item.id) {
            codes = item.code;
            this.appId = item.appId;
          }
        });

        if (
          this.isWeiXin() == true &&
          codes == 0 &&
          this.formData.payType == list.id
        ) {
          this.wx(null, 1, this);
        } else {
          if (codes == 0) {
            this.imagerurl =
              window.location.protocol +
              "//" +
              window.location.host +
              `/app/qrcode/qrcode?content=${encodeURIComponent(
                `${window.location.protocol}//${
                  window.location.host
                }/wap/index.html#/wechat?appId=${
                  this.appId
                }&form=${localStorage.getItem("buyJson")}&payId=${
                  this.payId
                }&shop=1`
              )}`;
            this.showss = true;
          } else {
            this.addShopOrderNew();
          }
        }
      },
      // 确认支付
      confirmBuyBtn() {
        if (this.payId) {
          let params = {};
          var cards1 = "";
          if (
            localStorage.getItem("userIds") ||
            localStorage.getItem("userIds") == ""
          ) {
            params = {
              shopId: this.detailInfo.id, //商品id、
              classId: this.detailInfo.shopClassId, //分类id
              userName: this.formData.username, //用户名
              userPhone: this.formData.userPhone, //手机号
              buyAddress: this.formData.area + this.formData.addressDetail, //用户地址
              orderRemark: this.formData.orderRemark, //备注
              // payType: this.formData.payType, //支付类型
              buyNumber: this.buyNumber,
              userId: localStorage.getItem("userIds"),
              collectID: this.formData.collectID,
            };
          } else {
            if (localStorage.getItem("meCardNum") != undefined) {
              cards1 = localStorage.getItem("meCardNum");
            }
            params = {
              shopId: this.detailInfo.id, //商品id、
              classId: this.detailInfo.shopClassId, //分类id
              userName: this.formData.username, //用户名
              userPhone: this.formData.userPhone, //手机号
              buyAddress: this.formData.area + this.formData.addressDetail, //用户地址
              orderRemark: this.formData.orderRemark, //备注
              // payType: this.formData.payType, //支付类型
              card: cards1, //卡号
              buyNumber: this.buyNumber,
              collectID: this.formData.collectID,
            };
          }

          localStorage.setItem("buyJson", JSON.stringify(params));
          let listv = [];
          this.payList.forEach((item) => {
            if (item.id == this.formData.payType) {
              listv = item;
            }
          });
          if (this.formData.payType == 1) {
            this.paylistFun(listv);
          } else {
            this.addShopOrderNew();
          }

          this.showBuy = !this.showBuy;
        } else {
          this.$notify({ type: "warning", message: "请选择商户" });
        }
      },
      // 支付
      addShopOrder() {
        let params = JSON.parse(localStorage.getItem("buyJson"));
        addShopOrder(
          this.$route.query.pay,
          params,
          this.$route.query.code
        ).then((res) => {
          if (res.status) {
            if (res.data) {
              // console.log(res.data);
              if (res.data.payType == 1) {
                var obj = {};
                obj = res.data.body;
                // console.log(obj);
                this.weixinSDK(
                  obj.appId,
                  obj.timeStamp,
                  obj.package,
                  obj.nonceStr,
                  obj.sign,
                  obj.signType
                );
              } else if (res.data.payType == 2) {
                window.location.href = res.data.body;
              } else if (res.data.payType == 3) {
                // console.log(res.data.body);
                this.imagerurl =
                  this.baseURL +
                  `/app/qrcode/qrcode?content=${encodeURIComponent(
                    res.data.body
                  )}`;
                // console.log(this.imagerurl);
                this.showss = true;
              }
            }
          } else {
            this.$toast(res.msg);
          }
        });
      },
      addShopOrderNew() {
        let params = {};
        if (
          localStorage.getItem("userIds") ||
          localStorage.getItem("userIds") == ""
        ) {
          params = {
            shopId: this.detailInfo.id, //商品id、
            classId: this.detailInfo.shopClassId, //分类id
            userName: this.formData.username, //用户名
            userPhone: this.formData.userPhone, //手机号
            buyAddress: this.formData.area + this.formData.addressDetail, //用户地址
            orderRemark: this.formData.orderRemark, //备注
            buyNumber: this.buyNumber,
            userId: localStorage.getItem("userIds"),
            collectID: this.formData.collectID,
          };
        } else {
          params = {
            shopId: this.detailInfo.id, //商品id、
            classId: this.detailInfo.shopClassId, //分类id
            userName: this.formData.username, //用户名
            userPhone: this.formData.userPhone, //手机号
            buyAddress: this.formData.area + this.formData.addressDetail, //用户地址
            orderRemark: this.formData.orderRemark, //备注
            card: localStorage.getItem("meCardNum"), //卡号
            buyNumber: this.buyNumber,
            collectID: this.formData.collectID,
          };
        }
        // console.log(this.payId, params);
        addShopOrder(this.payId, params, "").then((res) => {
          if (res.status) {
            if (res.data) {
              // console.log(res.data);
              if (res.data.payType == 1) {
                var obj = {};
                obj = res.data.body;
                // console.log(obj);
                this.weixinSDK(
                  obj.appId,
                  obj.timeStamp,
                  obj.package,
                  obj.nonceStr,
                  obj.sign,
                  obj.signType
                );
              } else if (res.data.payType == 2) {
                window.location.href = res.data.body;
              } else if (res.data.payType == 3) {
                // console.log(res.data.body);
                this.imagerurl = `/app/qrcode/qrcode?content=${encodeURIComponent(
                  res.data.body
                )}`;
                // console.log(this.imagerurl);
                this.showss = true;
              }
            } else {
              this.$toast(res.msg);
            }
          }
        });
      },
      isWeiXin() {
        undefined;
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          undefined;
          return true;
        } else {
          undefined;
          return false;
        }
      },
      weixinSDK(appid, timeStamp, package2, nonceStr, paySign, type) {
        function onBridgeReady() {
          window.WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: appid,
              timeStamp: timeStamp,
              nonceStr: nonceStr,
              package: package2,
              signType: type,
              paySign: paySign,
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                alert("下单成功");
              } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                alert("取消下单");
              } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                alert("下单失败");
              }
            }
          );
        }
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      },
      wx(code, type, than) {
        function jumpLink() {
          const url = encodeURIComponent(
            window.location.protocol +
              "//" +
              window.location.host +
              "/weixinRedirectShop?pay=" +
              than.payId
          );
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            than.appId +
            "&response_type=code&scope=snsapi_userinfo&redirect_uri=" +
            url;
        }
        getUserInfo();
        function getUserInfo() {
          if (code != null && code != undefined && code.trim() != "") {
            than.addShopOrder();
          } else {
            if (type == 1) {
              jumpLink();
            }
          }
        }
      },
    },
  };
</script>

<style lang="scss">
  .van-nav-bar__left {
    .van-icon {
      color: #fff !important;
    }
  }
  .van-nav-bar__title {
    color: #fff;
  }
  .recommend {
    display: flex;
    align-items: center;
    width: 27px;
    height: 100%;
  }
  .recommends {
    display: flex;
    align-items: center;
    background: #ffca66;
    color: #ffffff;
    width: 27px;
    justify-content: center;
    font-size: 9px;
    height: 15px;
    border-radius: 3px;
  }
  .sectionBox3 {
    height: 100vh;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    .topBox {
      width: 100%;
      position: fixed;
      top: 0px;
      z-index: 10;
      height: 46px;
    }
    .cardBox {
      position: relative;
      top: 46px;
      background-color: #f5f5f5 !important;
      height: calc(100% - 46px);
      // padding-bottom: 30px;
      z-index: 1;
      overflow: auto;
      .cardItem {
        margin: 10px;
        border-radius: 10px;
        background-color: #fff;
        padding: 10px;
        height: 60px;
        .left {
          float: left;
          width: 60px;
          height: 60px;
          text-align: center;
          .images {
            width: 60px;
            height: 60px;
            border-radius: 10px;
          }
        }
        .right {
          float: left;
          width: calc(100% - 70px);
          height: 60px;
          margin-left: 10px;
          text-align: left;
          .titles1 {
            font-size: 16px;
            color: #525252;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-top: 5px;
            margin-bottom: 10px;
          }
          .outBox {
            width: 65%;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            .titles2 {
              color: #1b8bff;
              display: inline-block;
            }
            .titles3 {
              display: inline-block;
              text-align: left;
              font-size: 12px;
              margin-left: 5px;
            }
          }

          .titles4 {
            width: 35%;
            display: inline-block;
            text-align: right;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .buyInfobox {
        clear: both;
        margin: 10px 10px 30px;
        .van-hairline--top-bottom::after,
        .van-hairline-unset--top-bottom::after {
          border-width: 0 !important;
        }
        .title {
          color: #0096ff;
          font-size: 14px;
          font-weight: 500;
          height: 40px;
          line-height: 40px;
          border-bottom: 1px solid #d2d2d2;
        }
        .formTitle {
          margin: 15px 5px 5px;
          font-size: 14px;
          color: #515151;
        }
        .inputBox {
          width: 100%;
          height: 40px;
          line-height: 40px;
          border: none;
          background: #f5f5f5;
          border-radius: 10px;
          overflow: hidden;
          padding: 0px 10px;
        }
        .van-cell__right-icon {
          margin-top: 8px;
        }
        .inputBox_diff {
          width: 100%;
          // height: 40px;
          // line-height: 40px;
          border: none;
          background: #f5f5f5;
          border-radius: 10px;
          padding: 8px 10px;
        }
      }
      .radioBox {
        .van-cell::after {
          border-bottom: 1px solid #acd3fd;
        }
      }
    }
    .buyBox {
      width: 100%;
      .btns {
        width: 100%;
        color: #fff;
        background: linear-gradient(45deg, #75b9ff, #0096ff);
        border-radius: 10px;
      }
    }
    .wrapper2 {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .block2 {
      width: 70%;
      background-color: #fff;
      border-radius: 10px;
      padding: 20px;
      .tit1 {
        font-size: 14px;
        color: #000;
      }
      .tit2 {
        font-size: 16px;
        color: #f00;
        margin-top: 3px;
        margin-bottom: 6px;
      }
      .inputDiv {
        margin-top: 20px;
        border-radius: 10px;
        background-color: #f5f5f5;
      }
      .confirmBuyBtn {
        margin-top: 15px;
        background-color: #1b8bff;
        width: 100%;
        height: 45px;
        color: #fff;
        border-color: #1b8bff;
        border-radius: 10px;
      }
    }
    .wrapper3 {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding: 10px;

      .block3 {
        width: calc(100% - 20px);
        background-color: #fff;
        border-radius: 10px;
        position: absolute;
        bottom: 10px;
        left: 10px;
        right: 10px;
        overflow: hidden;
        .titles {
          background-color: #1b8bff;
          width: 100%;
          height: 45px;
          color: #fff;
          font-size: 18px;
          line-height: 45px;
          margin-bottom: 10px;
        }

        .tips {
          font-size: 16px;
          color: #ee0a24;
          margin-top: 10px;
          padding: 6px 0px;
          border-top: 1px solid #addaff;
          border-bottom: 1px solid #addaff;
        }
        .inBlock {
          margin: 10px;
          div {
            height: 45px;
            margin-top: 15px;
          }
          .confirmBuyBtn1 {
            background-color: #1b8bff;
            width: 100%;
            height: 45px;
            color: #fff;
            border-color: #1b8bff;
            border-radius: 10px;
          }
          .confirmBuyBtn2 {
            background-color: #ff0000;
            width: 100%;
            height: 45px;
            color: #fff;
            border-color: #ff0000;
            border-radius: 10px;
          }
        }
      }
    }
  }
</style>
